import {TableConfig} from 'ng-zorro-antd/core/config';
import {NzConfig} from 'ng-zorro-antd/core/config/config';

export const TABLE_CONFIG_DEFAULT = {
  pageSize: 10,
  pageSizeOptions: [10,50,100]
}

export const TABLE_CONFIG:TableConfig = {
    nzBordered: false,
    nzSize: 'small',
    nzShowQuickJumper: true,
    nzHideOnSinglePage: false,
    nzSimple: false,
    nzShowSizeChanger: true,
    // nzLoadingIndicator:
}

export const SWITCH_CONFIG: NzConfig = {
  switch: {
    nzSize: 'small'
  }
}

export const COLLAPSE_CONFIG: NzConfig = {
  collapse: {
    nzGhost: false
  },

  collapsePanel: {
    nzShowArrow: false
  }
}

export const PAGINATION_CONFIG: NzConfig = {
  pagination: {
    nzSize: 'default',
    nzSimple: false,
    nzShowSizeChanger: true,
    nzShowQuickJumper: true,
    nzPageSizeOptions: TABLE_CONFIG_DEFAULT.pageSizeOptions
  }
}
